import React from "react";
import CallToAction from "../partials/cta";
import ErrorMessage from "../partials/error";
import SectionTitle from "../../../components/sectionTitle";
import { withStyles } from "@mui/styles";
import { useStyles } from "../indexFormStyles";
import FieldLabel from "../../../components/label";
import {
  Autocomplete,
  Box,
  Checkbox,
  FormControlLabel,
  TextField,
  Typography,
} from "@mui/material";
import { BUTTON_VERIFY_AND_PROCEED } from "../../../constants";

function BankDetailsForm({
  classes: { containerButton, formGroup, main },
  banks,
  declaration,
  errorMessage = null,
  errors = [],
  form = null,
  handleBack = {},
  handleChange,
  handleProceed,
  inputValue,
  isFormSubmitted = false,
  modal,
  onTextSearch,
  searchCount,
  selectedBankOption,
  setSelectedBankOption,
}) {
  return (
    <Box className={main}>
      <Box mt={2}>
        <Box display="flex" justifyContent="center" m={2} mt={1} mb={0}>
          <SectionTitle
            title={"Auto Mandate Setup"}
            onClickHandler={handleBack}
          />
        </Box>

        <Box className={formGroup}>
          <FieldLabel label={"Banks with Autopay UPI Enabled*"} />

          <Box
            display="flex"
            justifyContent="flex-start"
            alignItems="flex-start"
            textAlign="left"
            mb={1}
          >
            <Typography variant="caption">
              <small>
                Search for at least 3 characters, then select a bank from the
                list.
              </small>
            </Typography>
          </Box>

          <Autocomplete
            disablePortal
            id="combo-box-demo"
            options={banks}
            value={selectedBankOption}
            onChange={(event, newValue) => {
              setSelectedBankOption(newValue);
            }}
            noOptionsText={"No match found"}
            onInputChange={(event, newValue, reason) => {
              if (reason === "input") {
                if (newValue.length >= 3 || !newValue) {
                  const filteredOptions = banks.filter((opt) =>
                    opt.label.toLowerCase().includes(newValue.toLowerCase())
                  );

                  onTextSearch(newValue, filteredOptions.length);
                }
              }
            }}
            fullWidth
            renderInput={(params) => <TextField {...params} label="" />}
            sx={{
              "& + .MuiAutocomplete-popper .MuiAutocomplete-option": {
                backgroundColor: "#F6F6F6",
                fontWeight: "400 !important",
                display: "flex",
                justifyContent: "flex-start",
                textAlign: "left",
                margin: "2px 0px",
              },
            }}
          />
        </Box>

        <ErrorMessage errors={errors} modal={modal} />

        <Box
          className={containerButton}
          justifyContent="center"
          alignContent="center"
        >
          {((selectedBankOption?.code &&
            selectedBankOption?.is_mandate != "1" &&
            searchCount > 0) ||
            searchCount === 0) && (
            <Box ml={0.5} mr={0.5}>
              <Box
                display="flex"
                justifyContent="flex-start"
                alignItems="flex-start"
                textAlign="left"
              >
                <FormControlLabel
                  control={
                    <Box style={{ alignSelf: "start" }}>
                      <Checkbox
                        checked={declaration.agree}
                        onChange={handleChange}
                        name={"agree"}
                        color="primary"
                      />
                    </Box>
                  }
                  label={
                    <Box>
                      <Typography variant="caption">
                        Bank is not available
                      </Typography>
                    </Box>
                  }
                />
              </Box>

              <Box
                display="flex"
                justifyContent="flex-start"
                alignItems="flex-start"
                textAlign="left"
                mb={2}
              >
                <Typography variant="body1">
                  Please Note: Payment Mandate will not be set-up if "Bank is
                  not Available" is selected. Only 1st time payment will be
                  done.
                </Typography>
              </Box>
            </Box>
          )}

          <CallToAction
            buttonType={"click"}
            errorMessage={errorMessage}
            form={form}
            isDisabled={
              !(
                declaration.agree ||
                (selectedBankOption?.code &&
                  selectedBankOption?.is_mandate === "1")
              )
            }
            isFormSubmitted={isFormSubmitted}
            text={BUTTON_VERIFY_AND_PROCEED}
            handleClick={handleProceed}
          />
        </Box>
      </Box>
    </Box>
  );
}

export default withStyles(useStyles, { withTheme: true })(BankDetailsForm);
